import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        marginBottom: 36,
    },
    inputContainer: {
        width: 328,
    },
    errorInput: {
        width: 328,
        fontFamily: Fonts.main.regular,
        paddingHorizontal: 22,
    },
});

export default styles;
